import { render, staticRenderFns } from "./InformationFill.vue?vue&type=template&id=67641866"
import script from "./InformationFill.vue?vue&type=script&lang=js"
export * from "./InformationFill.vue?vue&type=script&lang=js"
import style0 from "./InformationFill.vue?vue&type=style&index=0&id=67641866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports